/*

    Export object definition:
        {
            { numColumns }: [
                [{ columnWidth }, { ?columnWidth }, ...]
            ]
        }


        numColumns = the number of columns being displayed
        columnWidth = the width of each column, represented as a fraction

 */

export default {
    1: [
        ['1/1'],
    ],

    2: [
        ['1/2', '1/2'],
        ['1/3', '2/3'],
        ['2/3', '1/3'],
        ['1/4', '3/4'],
        ['3/4', '1/4'],
        ['1/5', '4/5'],
        ['4/5', '1/5'],
        ['1/1', '1/1'],
    ],

    3: [
        ['1/3', '1/3', '1/3'],
        ['1/4', '1/2', '1/4'],
        ['1/4', '1/4', '1/2'],
        ['1/2', '1/4', '1/4'],
        ['1/5', '3/5', '1/5'],
        ['1/5', '1/5', '3/5'],
        ['3/5', '1/5', '1/5'],
        ['1/2', '1/2', '1/1'],
        ['1/3', '2/3', '1/1'],
        ['2/3', '1/3', '1/1'],
        ['1/4', '3/4', '1/1'],
        ['3/4', '1/4', '1/1'],
        ['1/1', '1/1', '1/1'],
    ],

    4: [
        ['1/4', '1/4', '1/4', '1/4'],
        ['1/6', '1/3', '1/3', '1/6'],
        ['1/3', '1/6', '1/6', '1/3'],
        ['1/3', '1/6', '1/3', '1/6'],
        ['1/6', '1/3', '1/6', '1/3'],
        ['1/2', '1/2', '1/2', '1/2'],
        ['1/3', '2/3', '2/3', '1/3'],
        ['2/3', '1/3', '1/3', '2/3'],
        ['2/3', '1/3', '2/3', '1/3'],
        ['1/3', '2/3', '1/3', '2/3'],
        ['1/1', '1/1', '1/1', '1/1'],
    ],

    5: [
        ['1/5', '1/5', '1/5', '1/5', '1/5'],
        ['1/2', '1/2', '1/2', '1/2', '1/1'],
        ['1/1', '1/1', '1/1', '1/1', '1/1'],
    ],

    6: [
        ['1/6', '1/6', '1/6', '1/6', '1/6', '1/6'],
        ['1/2', '1/2', '1/2', '1/2', '1/2', '1/2'],
        ['1/1', '1/1', '1/1', '1/1', '1/1', '1/1'],
    ],
};
